<template>
    <div>
        <div class="row" id="headlines-page">
            <div class="col-lg-12 mt-3 text-center" id="headlines">
                <div :class="{active: $route.name === 'accountHead'}" class="headline-item mb-1" @click="onHeadlineClicked('accountHead')" v-if="companyType ==='5'">
                    <h5>سرفصلهای حسابداری</h5>
                </div>
                <div :class="{active: $route.name === 'bank'}" class="headline-item mb-1" @click="onHeadlineClicked('bank')">
                    <h5>بانک</h5>
                </div>
                <div :class="{active: $route.name === 'cash-desk'}" class="headline-item mb-1" @click="onHeadlineClicked('cash-desk')">
                    <h5>صندوق</h5>
                </div>
                <div :class="{active: $route.name === 'provider'}" class="headline-item mb-1" @click="onHeadlineClicked('provider')" >
                    <h5>تامین کننده</h5>
                </div>
                <div :class="{active: $route.name === 'customer'}" class="headline-item mb-1" @click="onHeadlineClicked('customer')">
                    <h5>مشتری</h5>
                </div>
                <div :class="{active: $route.name === 'check-book'}" class="headline-item mb-1" @click="onHeadlineClicked('check-book')" >
                    <h5>چک</h5>
                </div>
                <div :class="{active: $route.name === 'cost'}" class="headline-item mb-1" @click="onHeadlineClicked('cost')">
                    <h5>هزینه</h5>
                </div>
                <div :class="{active: $route.name === 'income'}" class="headline-item mb-1" @click="onHeadlineClicked('income')">
                    <h5>درآمد</h5>
                </div>
                <div :class="{active: $route.name === 'category'}" class="headline-item mb-1" @click="onHeadlineClicked('category')">
                    <h5>دسته بندی</h5>
                </div>
                <div :class="{active: $route.name === 'headline-products'}" class="headline-item mb-1" @click="onHeadlineClicked('headline-products')">
                    <h5>محصولات</h5>
                </div>
                <div :class="{active: $route.name === 'headline-Units'}" class="headline-item mb-1" @click="onHeadlineClicked('headline-Units')">
                    <h5>واحد ها</h5>
                </div>
            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
            <div class="sk-circle" id="loadings">
                <div class="sk-circle1 sk-child"></div>
                <div class="sk-circle2 sk-child"></div>
                <div class="sk-circle3 sk-child"></div>
                <div class="sk-circle4 sk-child"></div>
                <div class="sk-circle5 sk-child"></div>
                <div class="sk-circle6 sk-child"></div>
                <div class="sk-circle7 sk-child"></div>
                <div class="sk-circle8 sk-child"></div>
                <div class="sk-circle9 sk-child"></div>
                <div class="sk-circle10 sk-child"></div>
                <div class="sk-circle11 sk-child"></div>
                <div class="sk-circle12 sk-child"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    $(function() {
        var pos1 = 0;
        $(window).scroll(function() {
            var pos2 = $(window).scrollTop();
            if(pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if(pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(()=> {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'haedlines',
        components: {},
        data() {
            return {
                providers: [],
                categories: [],
                queryParams: {
                    pageSize: 18,
                    pageIndex: 0,
                    name: "",
                    categoryId: 0
                },
                searchString: "",
                modalProductName: "",
                cart: [],
                companyType: ""

            }
        } ,
        mounted() {
            $("#loadings").hide();
            this.companyType = localStorage.getItem("companyType");
        },
        methods: {
            onHeadlineClicked(headline) {
                this.$router.push({
                    name: `${headline}`,

                });
            }
        }
    }
</script>

<style scoped>
    #loading {
        position: absolute;
        top: calc(40% - 40px);
        left: calc(50% - 40px);
    }
</style>